import { TransformDate } from '../../../decorators/transform-date.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { ContactSourceEnum } from '../../../enums/contact-source.enum';
import { ContactTitleEnum } from '../../../enums/contact-title.enum';
import { CountryDto } from '../../settings/dtos/country.dto';

export abstract class BaseContactDto {
  @TransformInt()
  id?: number;
  source?: ContactSourceEnum | null;
  companyName?: string | null;
  companyRegNumber?: string | null;
  companyTaxNumber?: string | null;
  companyVatNumber?: string | null;
  firstName?: string | null;
  middleNames?: string | null;
  lastName?: string | null;
  title!: ContactTitleEnum;
  @TransformDate()
  dateOfBirth?: Date | null;
  email?: string | null;
  address1?: string | null;
  address2?: string | null;
  phoneLandline?: string | null;
  phoneMobile?: string | null;
  phoneFax?: string | null;
  @TransformDate()
  preferredContactFrom?: Date | null;
  @TransformDate()
  preferredContactTo?: Date | null;
  city?: string | null;
  postCode?: string | null;
  poBox?: string | null;
  county?: string | null;
  state?: string | null;
  @TransformInt()
  countryId?: number | null;
  country?: CountryDto | null;
  website?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  twitter_x?: string | null;
  slack?: string | null;
  whatsApp?: string | null;
  youtube?: string | null;
  linkedIn?: string | null;
}
